// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__w7kc3","small":"style_small__Wyfz7","medium":"style_medium__r9Cv1","large":"style_large__upB0+"};